<template>
  <div>
    <b-notification :has-icon="true" icon="file" :closable="false">
      {{ $t('compCarbonFormsBuildingsHelpFileFormat.text-1') }}
      <br /><br />
      <ul style="list-style-type: square; margin-left: 25px">
        <li>
          <span v-html="$t('compCarbonFormsBuildingsHelpFileFormat.type-1')" />
          ({{ $t('compCarbonFormsBuildingsHelpFileFormat.info-1') }}
          <a
            class="link"
            target="_blank"
            href="/static/carbon/buildingTemplate.tsv"
            >{{ $t('compCarbonFormsBuildingsHelpFileFormat.info-1a') }}</a
          >
          {{ $t('compCarbonFormsBuildingsHelpFileFormat.info-1b') }}
          <a
            class="link"
            target="_blank"
            href="/static/carbon/buildingTemplate.csv"
          >
            {{ $t('compCarbonFormsBuildingsHelpFileFormat.info-1c') }}</a
          >) :
          {{ $t('compCarbonFormsBuildingsHelpFileFormat.desc-1') }}
        </li>
        <li>
          <span v-html="$t('compCarbonFormsBuildingsHelpFileFormat.type-2')" />
          ({{ $t('compCarbonFormsBuildingsHelpFileFormat.info-1') }}
          <a
            class="link"
            target="_blank"
            href="/static/carbon/refrigerantTemplate.tsv"
            >{{ $t('compCarbonFormsBuildingsHelpFileFormat.info-1a') }}</a
          >
          {{ $t('compCarbonFormsBuildingsHelpFileFormat.info-1b') }}
          <a
            class="link"
            target="_blank"
            href="/static/carbon/refrigerantTemplate.csv"
          >
            {{ $t('compCarbonFormsBuildingsHelpFileFormat.info-1c') }}</a
          >) :
          {{ $t('compCarbonFormsBuildingsHelpFileFormat.desc-2') }}
        </li>
      </ul>
    </b-notification>
    <b-tabs class="block">
      <b-tab-item :label="$t('compCarbonFormsBuildingsHelpFileFormat.tab-1')">
        <ul style="list-style-type: square; margin-left: 25px">
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-1')"></li>
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-1a')"></li>
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-2')"></li>
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-3')"></li>

          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-5')"></li>
          <li>
            <span v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-6')" />
          </li>
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-6a')"></li>
          <li>
            <span v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-7')" />
          </li>
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-8')"></li>
          <br />
          <b-notification :closable="false">
            <div class="columns">
              <div class="column">
                <b-field
                  :label="$t('compCarbonFormsBuildingsHelpFileFormat.label-1')"
                >
                  <b-autocomplete
                    expanded
                    name="network"
                    :placeholder="
                      $t('compCarbonFormsBuildingsHelpFileFormat.placeholder')
                    "
                    v-model="urbanNetwork"
                    open-on-focus
                    :data="filteredUrbanNetwork()"
                    field="description_FR"
                    @select="(option) => (selected = option)"
                    clearable
                  />
                </b-field>
              </div>
              <div class="column is-one-third">
                <b-field
                  :label="$t('compCarbonFormsBuildingsHelpFileFormat.label-2')"
                >
                  <b-input
                    :value="networkID(selected)"
                    :readonly="true"
                  ></b-input>
                  <p class="control" expanded>
                    <b-button
                      :disabled="selected ? false : true"
                      class="button"
                      type="is-primary"
                      icon-left="copy"
                      v-clipboard:copy="networkID(selected)"
                      v-clipboard:success="copySuccess"
                      v-clipboard:error="copyError"
                    >
                      {{ $t('copy') }}
                    </b-button>
                  </p>
                </b-field>
              </div>
            </div>
          </b-notification>
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-9')" />
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-10')" />
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-11')" />
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-12')" />
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-13')" />
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-14')" />
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-15')" />
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-16')" />
          <li>
            <span
              v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-17')"
            />
            {{ heatingType }}.
            <span
              v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-18')"
            />
          </li>
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.enf-19')" />
        </ul>
        <br />
        <p v-html="$t('compCarbonFormsBuildingsHelpFileFormat.footnote')" />
      </b-tab-item>
      <b-tab-item :label="$t('compCarbonFormsBuildingsHelpFileFormat.tab-2')">
        <ul style="list-style-type: square; margin-left: 25px">
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.ref-1')" />
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.ref-2')" />
          <li v-html="$t('compCarbonFormsBuildingsHelpFileFormat.ref-3')" />
          <br />
          <div class="columns">
            <div class="column is-11">
              <b-notification :closable="false">
                <b-field
                  :label="$t('compCarbonFormsBuildingsHelpFileFormat.label-3')"
                >
                  <b-autocomplete
                    expanded
                    name="refrigerantId"
                    :placeholder="
                      $t('compCarbonFormsBuildingsHelpFileFormat.placeholder-2')
                    "
                    v-model="refrigerant"
                    open-on-focus
                    :data="filteredRefrigerants()"
                    :custom-formatter="
                      (option) => getRefrigerantDescription(option)
                    "
                    @select="(option) => (selectedRefrigerant = option)"
                    clearable
                  />
                  <p class="control">
                    <b-button
                      class="button"
                      type="is-primary"
                      icon-left="copy"
                      v-clipboard:copy="
                        getRefrigerantDescription(selectedRefrigerant)
                      "
                      v-clipboard:success="copySuccess"
                      v-clipboard:error="copyError"
                    >
                      {{ $t('copy') }}
                    </b-button>
                  </p>
                </b-field>
              </b-notification>
            </div>
          </div>
        </ul>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import Building from '@/models/carbon/Building.js'
import Modules from '@/models/Modules.js'

export default {
  name: 'HelpFileFormat',
  data () {
    return {
      selected: null,
      selectedRefrigerant: null,
      urbanNetwork: '',
      refrigerant: ''
    }
  },
  computed: {
    heatingType: function () {
      return Object.keys(Building.heatingTypes)
    },
    urbanNetworks: function () {
      return Building.getUrbanNetworks()
    },
    refrigerants: function () {
      return Building.getRefrigerants()
    }
  },

  methods: {
    filteredUrbanNetwork () {
      return this.urbanNetworks.filter((option) => {
        return (
          option.description_FR
            .toString()
            .toLowerCase()
            .indexOf(this.urbanNetwork.toLowerCase()) >= 0
        )
      })
    },
    filteredRefrigerants () {
      return this.refrigerants.filter((option) => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.refrigerant.toLowerCase()) >= 0
        )
      })
    },
    networkID (selected) {
      if (selected) {
        return selected.network
      } else {
        return null
      }
    },
    copySuccess: function () {
      this.$buefy.toast.open({
        message: this.$t('compCarbonFormsBuildingsHelpFileFormat.toast-1'),
        type: 'is-light'
      })
    },
    copyError: function () {
      this.$buefy.toast.open({
        message: this.$t('compCarbonFormsBuildingsHelpFileFormat.toast-2'),
        type: 'is-danger is-light'
      })
    },
    getRefrigerantDescription: function (type) {
      if (type) {
        return Building.getDescription(Modules.REFRIGERANTS, type)
      } else {
        return null
      }
    }
  }
}
</script>
